export default "__VITE_ASSET__SHHU3p_y__"